import { cn as cnUtil } from "../util/cn.js";

export const cn = cnUtil;
